"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "macerata-campania": {
    "010614ce": [{
      "hkey": "8afb0fef",
      "slug": "macerata-campania",
      "name": "Macerata Campania",
      "primary": true,
      "skipSearch": false
    }],
    "casalba": [{
      "hkey": "8afb0fef",
      "slug": "macerata-campania",
      "name": "Macerata Campania",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12303bce": [{
      "hkey": "8afb0fef",
      "slug": "macerata-campania",
      "name": "Macerata Campania",
      "primary": true,
      "skipSearch": false
    }],
    "caturano": [{
      "hkey": "8afb0fef",
      "slug": "macerata-campania",
      "name": "Macerata Campania",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;